import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { NewReleaseComponent } from './new-release/new-release.component';
import { LoginComponent } from './login/login.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { NewReleaseBundleComponent } from './new-release-bundle/new-release-bundle.component';
import { ExternalLoginComponent } from './external-login/external-login.component';
import { ChangePasswordComponent } from './change-password/change-password.component';

import { AuthGuard } from './auth-guard.service';
import { DeactivateGuardService } from './deactivate-guard.service';


const appRoutes: Routes = [
  { path: '', redirectTo: '/Home', pathMatch: 'full' },
  { path: 'home', redirectTo: '/Home', pathMatch: 'full', canActivate: [AuthGuard] },
  { path: 'New-Release', component: NewReleaseComponent, canActivate: [AuthGuard], canDeactivate: [DeactivateGuardService] },
  { path: 'New-Release-Bundle', component: NewReleaseBundleComponent, canActivate: [AuthGuard] },
  { path: 'changePassword', component: ChangePasswordComponent, canActivate: [AuthGuard]},
  { path: 'rb', redirectTo: '/Release-Bundles', pathMatch: 'full' },
  { path: 'Login', component: LoginComponent },
  { path: 'ExternalLogin', component: ExternalLoginComponent},
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule]
})

export class AppRoutingModule { }
